import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { ComponentWithForm } from '@bringg/react-pages/dist/components';

import { FleetTemplateSelection } from '../../../../stores/fleets/fleets-store';

const AvailableFleetsButtons = observer(({ form, defaultValues }: ComponentWithForm<FleetTemplateSelection>) => {
	const { t } = useTranslation();

	const selectAll = useCallback(() => {
		Object.keys(defaultValues).forEach(key => {
			form.setValue(key, true, { shouldDirty: true });
		});
	}, [defaultValues, form]);

	const clearAll = useCallback(() => {
		Object.keys(defaultValues).forEach(key => {
			form.setValue(key, false, { shouldDirty: true });
		});
	}, [defaultValues, form]);

	return (
		<span className="select-buttons">
			<span className="select-all" onClick={selectAll}>
				{t('FLEET_ROUTER.SELECT_ALL_FLEETS')}
			</span>
			<span className="select-separator">|</span>
			<span className="clear-all" onClick={clearAll}>
				{t('FLEET_ROUTER.CLEAR_ALL_FLEETS')}
			</span>
		</span>
	);
});

export default AvailableFleetsButtons;
